import { all, put, takeEvery } from "redux-saga/effects";
import { fetcher, getErrorMsg, handleError } from "lib/fetch";
import * as actions from "./actions";

const url = "strengths"

function* loadStrengths(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(url, params, token);
    yield put(actions.loadStrengths.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.loadStrengths.failure(getErrorMsg(error)));
  }
}

function* showStrength(action) {
  try {
    const { id, token } = action.payload;
    const res = yield fetcher.get(`${url}/${id}`, token);
    yield put(actions.showStrength.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.showStrength.failure(getErrorMsg(error)));
  }
}

function* createStrength(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(`${url}/create`, params, token);
    yield put(actions.createStrength.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.createStrength.failure(getErrorMsg(error)));
  }
}

function* updateStrength(action) {
  try {
    const { params, id, token } = action.payload;
    const res = yield fetcher.post(`${url}/update/${id}`, params, token);
    yield put(actions.updateStrength.success(res.data));
   
  } catch (error) {
    handleError(error);
    yield put(actions.updateStrength.failure(getErrorMsg(error)));
  }
}

function* deleteStrength(action) {
  try {
    const { id, token } = action.payload;
    yield fetcher.get(`${url}/delete/${id}`, token);
    yield put(actions.deleteStrength.success(id));
  } catch (error) {
    handleError(error);
    yield put(actions.deleteStrength.failure(getErrorMsg(error)));
  }
}

function* importStrength(action) {
  try {
    const { file, token } = action.payload;
    const formData = new FormData();
    formData.append("file_name", file.originFileObj);
    const res = yield fetcher.upload(`${url}/import`, formData, token);
    yield put(actions.importStrength.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.importStrength.failure(getErrorMsg(error)));
  }
}

function* exportStrength(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(`${url}/export`, params, token);
    yield put(actions.exportStrength.success(res.data));
    fetcher.download(res.data.data);
  } catch (error) {
    handleError(error);
    yield put(actions.exportStrength.failure(getErrorMsg(error)));
  }
}

export default function* watchStrength() {
  yield all([
    takeEvery(actions.LOAD_STRENGTH.REQUEST, loadStrengths),
    takeEvery(actions.SHOW_STRENGTH.REQUEST, showStrength),
    takeEvery(actions.CREATE_STRENGTH.REQUEST, createStrength),
    takeEvery(actions.UPDATE_STRENGTH.REQUEST, updateStrength),
    takeEvery(actions.DELETE_STRENGTH.REQUEST, deleteStrength),
    takeEvery(actions.IMPORT_STRENGTH.REQUEST, importStrength),
    takeEvery(actions.EXPORT_STRENGTH.REQUEST, exportStrength),
  ]);
}
